import { useIntl } from '@capsicum/common';

import { type UseNCWMigrationIndicatorProps } from '../../models';

export const useNCWMigrationIndicator = ({ variant }: UseNCWMigrationIndicatorProps) => {
	const { $t } = useIntl();

	return {
		intlText: {
			migratingText:
				variant === 'ncw' ? $t('ncWallet.home.migrationPending') : $t('ncWallet.home.v2MigrationPending')
		}
	};
};
